import { render, staticRenderFns } from "./priceModal.vue?vue&type=template&id=5fbe445b&scoped=true"
import script from "./priceModal.vue?vue&type=script&lang=ts"
export * from "./priceModal.vue?vue&type=script&lang=ts"
import style0 from "./priceModal.vue?vue&type=style&index=0&id=5fbe445b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fbe445b",
  null
  
)

export default component.exports